<template>
  <sl-side-panel v-model="visible" :mask-closable="false" :title="itemTitle">
    <sl-detail-list :col="1" label-width="100px" label-align="right">
      <sl-detail-list-item title="问题描述">{{data.description}}</sl-detail-list-item>
      <sl-detail-list-item title="照片">
        <sl-carousel :images="photos" />
      </sl-detail-list-item>
      <!-- <Row label-width="90" v-show="fullVisible"> -->
        <sl-detail-list-item title="反馈类型">{{data.typeText}}</sl-detail-list-item>
        <sl-detail-list-item title="车辆编号">{{data.carNo}}</sl-detail-list-item>
        <sl-detail-list-item title="损坏部位">{{data.partsDisplay}}</sl-detail-list-item>
        <sl-detail-list-item title="提交用户类型">{{data.userTypeText}}</sl-detail-list-item>
        <sl-detail-list-item title="提交用户姓名">{{data.createName}}</sl-detail-list-item>
        <sl-detail-list-item title="提交用户电话">{{data.phone}}</sl-detail-list-item>
        <sl-detail-list-item title="提交来源">{{data.deviceText}}</sl-detail-list-item>
        <sl-detail-list-item title="提交时间">{{data.createDatetimeText}}</sl-detail-list-item>
      <!-- </Row> -->
      <!-- <div @click="handleToggleVisible" > -->
        <!-- <Divider style="font-size: 13px;cursor:pointer;color:rgba(0,0,0,.65);">{{moreLabel}}</Divider> -->
      <!-- </div> -->
    </sl-detail-list>
    <div slot="header">
      <Button v-permission="'support.ticket.deal'" type="default" @click="handleDeal" ghost>{{dealLabel}}</Button>
    </div>

  </sl-side-panel>
</template>
<script>

const partsDisplay = (d) => {
  if(d.partsInfoList && d.partsInfoList.length){
    return d.partsInfoList.map(i => i.name).join(';')
  }else{
    return ''
  }
}
export default {
  data() {
    return {
      id: null,
      data:{},
      loading: false,
      visible: false,
      fullVisible:false
    }
  },

  created() {

  },
  computed: {
    itemTitle() {
      return this.data.feedbackNo ? `工单：${this.data.feedbackNo}` : '工单'
    },
    moreLabel(){
      return this.fullVisible ? '收起' : '查看更多'
    },
    dealLabel(){
      return this.data.state == 0 ? '标记为已处理' : '标记为未处理'
    },
    photos(){
      return this.data.photo ? this.data.photo.split(';') : []
    }
  },
  methods: {
    query() {
      this.$request.ticket(this.id).then(resp => {
        this.data = this.$utils.conv(resp.data , {'type':'$ticketType' , 'createDatetime':'datetime' , 'userType':'$userType' , partsDisplay , device:'$ticketSource'})
      })
    },

    init(id) {
      this.id = id
      this.visible = true
      this.reset()
      if (this.id) {
        this.query()
      }
    },

    reset() {
      this.data = {}
    },

    save() {
      
    },
    handleToggleVisible(){
      this.fullVisible = !this.fullVisible
    },
    handleDeal(){
      let msg = '确定标记为' + (this.data.state == 0 ? '已处理' : '未处理')
      this.$ui.confirm(this.$request.ticketDeal,msg)(this.data.id).then(resp => {
        if(resp.code){
          this.$Modal.error({content:resp.msg})
        }else{
          this.$Message.success({content:'操作成功'})
          this.query()
        }
        this.$emit('on-update')

      })
    }
  }
}

</script>
